import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';
import { EvaluacionParticipanteDTO } from 'src/app/core/models/vinculacion/vinculacion-Interfaces';
import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlVinculacion;

@Injectable()
export class EvaluacionParticipanteService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) {}

  getEvaluacionParticipanteService(): Observable<BodyListResponse<EvaluacionParticipanteDTO>> {
    return this.http.get<BodyListResponse<EvaluacionParticipanteDTO>>(API_URL + '/api/v1/evaluacionParticipante/todos');
  }

  guardarEvaluacionParticipanteService(evaluacionParticipanteDTO: EvaluacionParticipanteDTO): Observable<BodyResponse<EvaluacionParticipanteDTO>> {
    return this.http.post<any>(API_URL + '/api/v1/evaluacionParticipante', evaluacionParticipanteDTO);
  }

  getEvaluacionParticipantePorCodigoService(codigo: string): Observable<BodyResponse<EvaluacionParticipanteDTO>> {
    return this.http.get<BodyResponse<EvaluacionParticipanteDTO>>(API_URL + '/api/v1/evaluacionParticipante/' + codigo);
  }
}
